export default __webpack_public_path__ + "static/media/logo.c69b6722.png";